import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import sanitizeHtml from 'sanitize-html';
import validator from 'validator';
import throttle from 'lodash.throttle';
import { Tabs, Form, Input, message } from 'antd';
import { EditorElementPopover } from '../EditorElementPopover';

const FormItem = Form.Item;

export class PForm extends React.Component {
  state = {
    showBtn: false,
    messageValidateStatus: 'success',
    messageHelp: '',
    urlValidateStatus: 'success',
    urlHelp: '',
  };

  static propTypes = {
    name: PropTypes.string,
    targetType: PropTypes.string,
    targetUrl: PropTypes.string,
    targetMessage: PropTypes.string,

    children: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.object,
    ]),

    className: PropTypes.string,

    address: PropTypes.array,
    updateNode: PropTypes.func,

    publish: PropTypes.bool,
  };

  static defaultProps = {
    name: 'no-name',
    targetType: 'message',
    targetMessage: 'Thank you. We have received your message.',
    publish: false,
  };

  onPopoverMouseOver = (e) => {
    e.stopPropagation();
  };

  onPopoverMouseOut = (e) => {
    e.stopPropagation();
  };

  targetTypeChanged = (v) => {
    this.props.updateNode(this.props.address, { targetType: v });
  };

  throttleValidateMessage = throttle((value) => {
    const sanitized = sanitizeHtml(value.trim(), {
      allowedTags: [],
      allowedAttributes: {},
    });
    if (sanitized.length > 140) {
      this.setState({
        messageValidateStatus: 'warning',
        messageHelp: 'too long',
      });
    }
    else if (sanitized.length === 0) {
      this.setState({
        messageValidateStatus: 'warning',
        messageHelp: 'cannot be empty',
      });
    }
    else {
      this.setState({
        messageValidateStatus: 'success',
        messageHelp: null,
      });
      this.props.updateNode(this.props.address, { targetMessage: sanitized });
    }
  }, 300);

  targetMessageChanged = (e) => {
    this.throttleValidateMessage(e.target.value);
  };

  // validateUrl = (url) => /^((https?|ftp|smtp):\/\/)?(www.)?[a-z0-9]+\.[a-z]+(\/[a-zA-Z0-9#]+\/?)*$/i.test(url);

  throttleValidateUrl = throttle((value) => {
    const url = value.trim();
    const validated = validator.isUrl(url);
    if (!validated) {
      this.setState({
        urlValidateStatus: 'warning',
        urlHelp: 'invalid url',
      });
    }
    else {
      this.setState({
        urlValidateStatus: 'success',
        urlHelp: null,
      });
      this.props.updateNode(this.props.address, { targetUrl: url });
    }
  }, 300);

  targetUrlChanged = (e) => {
    this.throttleValidateUrl(e.target.value);
  }

  popoverContent = () => {
    const { targetType, targetUrl, targetMessage } = this.props;
    return (
      <React.Fragment>

        <div className="label">
          <div className="main">Feedback</div>
          <div className="help">Choose what to show visitors once they submit the form.</div>
        </div>

        <Tabs defaultActiveKey={targetType} onChange={this.targetTypeChanged} type="card">
          <Tabs.TabPane tab="Message" key="message">
            <div className="helpColor">A brief popup confirmation message</div>
            <FormItem
              validateStatus={this.state.messageValidateStatus}
              hasFeedback={false}
              help={this.state.messageHelp}
            >
              <Input onChange={this.targetMessageChanged} defaultValue={targetMessage} />
            </FormItem>
          </Tabs.TabPane>
          <Tabs.TabPane tab="Url" key="url">
            <div className="helpColor">A different URL to navigate to</div>
            <FormItem
              validateStatus={this.state.urlValidateStatus}
              hasFeedback={false}
              help={this.state.urlHelp}
            >
              <Input onChange={this.targetUrlChanged} defaultValue={targetUrl} />
            </FormItem>
          </Tabs.TabPane>
        </Tabs>
      </React.Fragment>
    );
  };

  onMouseOver = (e) => {
    this.setState({ showBtn: true });
    e.stopPropagation();
  };

  onMouseOut = (e) => {
    this.setState({ showBtn: false });
    e.stopPropagation();
  };

  handleSubmit = (e) => {
    e.preventDefault();
    message.warning('Forms disabled in edit mode');
  }

  render() {
    const { targetType, targetMessage, targetUrl, publish, name } = this.props;

    return (
      <div
        className={cx(
          'pform',
        )}
        onMouseOver={this.onMouseOver}
        onFocus={this.onMouseOver}
        onMouseOut={this.onMouseOut}
        onBlur={this.onMouseOut}
      >
        <form
          className={cx(
            this.props.className,
            'pagehits-hook': publish,
          )}
          data-name={name}
          data-target-type={targetType}
          data-target-message={targetMessage}
          data-target-url={targetUrl}
          onSubmit={this.handleSubmit}
        >
          { this.props.children }
        </form>

        <EditorElementPopover
          usecase="form"
          showBtn={this.state.showBtn}
          title="Form settings"
          content={this.popoverContent()}
          placement="bottomLeft"
          btnLabel="form"
          publish={publish}
        />

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./scripts/components/editor/elements/PForm.jsx